// import React from "react";

// const StockSummaryReportGenerator = () => {
//     const [fromDate, setFromDate] = React.useState('');
//     const [toDate, setToDate] = React.useState('');
//     const [stockType, setStockType] = React.useState('');
//     const [year, setYear] = React.useState('');
//     const [godowns, setGodowns] = React.useState([]);
//     const [groups, setGroups] = React.useState([]);
//     const [products, setProducts] = React.useState([]);
  
//     const handlePrint = () => {
//       alert('Generating stock summary report...');
//     };
  
//     return (
//       <div style={{ 
//         padding: '1rem', 
//         maxWidth: '42rem', 
//         margin: '0 auto',
//         fontFamily: 'sans-serif'
//       }}>
//         <h1 style={{ 
//           fontSize: '1.5rem', 
//           fontWeight: 'bold', 
//           marginBottom: '1rem',
//           color: '#1a1a1a'
//         }}>
//           Stock Summary Report Generator
//         </h1>
        
//         <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
//           <input
//             type="date"
//             style={{ 
//               border: '1px solid #e2e8f0',
//               padding: '0.5rem',
//               borderRadius: '0.25rem',
//               flex: '1',
//               minWidth: '150px'
//             }}
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             placeholder="From Date"
//           />
//           <input
//             type="date"
//             style={{ 
//               border: '1px solid #e2e8f0',
//               padding: '0.5rem',
//               borderRadius: '0.25rem',
//               flex: '1',
//               minWidth: '150px'
//             }}
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             placeholder="To Date"
//           />
//           <select 
//             style={{ 
//               border: '1px solid #e2e8f0',
//               padding: '0.5rem',
//               borderRadius: '0.25rem',
//               flex: '1',
//               minWidth: '150px'
//             }} 
//             value={stockType} 
//             onChange={(e) => setStockType(e.target.value)}
//           >
//             <option value="">- SELECT -</option>
//             <option value="stock">Stock</option>
//           </select>
//           <select 
//             style={{ 
//               border: '1px solid #e2e8f0',
//               padding: '0.5rem',
//               borderRadius: '0.25rem',
//               flex: '1',
//               minWidth: '150px'
//             }} 
//             value={year} 
//             onChange={(e) => setYear(e.target.value)}
//           >
//             <option value="">- SELECT -</option>
//             <option value="2025">2025</option>
//           </select>
//         </div>
        
//         <div style={{ 
//           display: 'flex', 
//           flexWrap: 'wrap', 
//           gap: '1rem', 
//           marginBottom: '1rem' 
//         }}>
//           <div style={{ 
//             flex: '1',
//             minWidth: '200px',
//             padding: '0.75rem',
//             backgroundColor: '#f8fafc',
//             borderRadius: '0.375rem',
//             border: '1px solid #e2e8f0'
//           }}>
//             <h2 style={{ 
//               fontWeight: '600', 
//               marginBottom: '0.75rem',
//               fontSize: '1.125rem'
//             }}>
//               Godown
//             </h2>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={godowns.includes('all')} 
//                 onChange={(e) => setGodowns(e.target.checked ? ['all'] : [])} 
//               /> All Godowns
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={godowns.includes('warehouse')} 
//                 onChange={(e) => setGodowns(e.target.checked ? ['warehouse'] : [])} 
//               /> Warehouse
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={godowns.includes('store')} 
//                 onChange={(e) => setGodowns(e.target.checked ? ['store'] : [])} 
//               /> Store
//             </label>
//           </div>
          
//           <div style={{ 
//             flex: '1',
//             minWidth: '200px',
//             padding: '0.75rem',
//             backgroundColor: '#f8fafc',
//             borderRadius: '0.375rem',
//             border: '1px solid #e2e8f0'
//           }}>
//             <h2 style={{ 
//               fontWeight: '600', 
//               marginBottom: '0.75rem',
//               fontSize: '1.125rem'
//             }}>
//               Group
//             </h2>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={groups.includes('all')} 
//                 onChange={(e) => setGroups(e.target.checked ? ['all'] : [])} 
//               /> All Groups
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={groups.includes('general')} 
//                 onChange={(e) => setGroups(e.target.checked ? ['general'] : [])} 
//               /> General
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={groups.includes('vegetable')} 
//                 onChange={(e) => setGroups(e.target.checked ? ['vegetable'] : [])} 
//               /> Vegetable
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={groups.includes('aluminum foil')} 
//                 onChange={(e) => setGroups(e.target.checked ? ['aluminum foil'] : [])} 
//               /> Aluminum Foil
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={groups.includes('bearing')} 
//                 onChange={(e) => setGroups(e.target.checked ? ['bearing'] : [])} 
//               /> Bearing
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={groups.includes('grocery')} 
//                 onChange={(e) => setGroups(e.target.checked ? ['grocery'] : [])} 
//               /> Grocery
//             </label>
//           </div>
          
//           <div style={{ 
//             flex: '1',
//             minWidth: '200px',
//             padding: '0.75rem',
//             backgroundColor: '#f8fafc',
//             borderRadius: '0.375rem',
//             border: '1px solid #e2e8f0'
//           }}>
//             <h2 style={{ 
//               fontWeight: '600', 
//               marginBottom: '0.75rem',
//               fontSize: '1.125rem'
//             }}>
//               Product
//             </h2>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('all')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['all'] : [])} 
//               /> All Products
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('prestige 1.5l')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['prestige 1.5l'] : [])} 
//               /> Prestige 1.5L
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('gas 21 kg')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['gas 21 kg'] : [])} 
//               /> Gas 21 KG
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('bt 4 lb')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['bt 4 lb'] : [])} 
//               /> BT 4 LB
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('screw driver')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['screw driver'] : [])} 
//               /> Screw Driver
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('front rimper')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['front rimper'] : [])} 
//               /> Front Rimper
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('ultra slim led display')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['ultra slim led display'] : [])} 
//               /> Ultra Slim LED Display
//             </label>
//             <label style={{ display: 'block', marginBottom: '0.5rem' }}>
//               <input 
//                 type="checkbox" 
//                 style={{ marginRight: '0.5rem' }}
//                 checked={products.includes('chain & dent in air')} 
//                 onChange={(e) => setProducts(e.target.checked ? ['chain & dent in air'] : [])} 
//               /> Chain & Dent In Air
//             </label>
//           </div>
//         </div>
        
//         <button 
//           style={{ 
//             backgroundColor: '#3b82f6',
//             color: 'white',
//             padding: '0.5rem 1rem',
//             borderRadius: '0.25rem',
//             border: 'none',
//             cursor: 'pointer',
//             fontSize: '1rem',
//             fontWeight: '500',
//             transition: 'background-color 0.2s',
//             marginTop: '0.5rem'
//           }}
//           onClick={handlePrint}
//           onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
//           onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
//         >
//           Print
//         </button>
//       </div>
//     );
//   };
  
//   export default StockSummaryReportGenerator;

import React, { useState, useEffect } from 'react';
import { database, auth } from '../firebase';
import { ref, onValue, off } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import ReactDOMServer from 'react-dom/server';

// Helper: Extract city from address
const getCityFromAddress = (address) => {
  if (!address) return 'Unknown City';
  const addressParts = address.trim().split(/\s+/);
  return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
};

// Filter Section Component
const FilterSection = ({ title, options, selected, onChange }) => {
  const handleCheckboxChange = (option) => {
    if (option === options[0]) { // "All" option
      if (selected.includes(option)) {
        onChange([]);
      } else {
        onChange([...options]);
      }
    } else {
      const newSelected = selected.includes(option)
        ? selected.filter(item => item !== option && item !== options[0])
        : [...selected.filter(item => item !== options[0]), option];
      
      if (newSelected.length === options.length - 1) {
        onChange([options[0], ...newSelected]);
      } else {
        onChange(newSelected);
      }
    }
  };

  return (
    <div style={{
      backgroundColor: '#f8fafc',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      maxWidth: '220px',
      marginBottom: '16px',
    }}>
      <h2 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
        borderBottom: '2px solid #3b82f6',
        paddingBottom: '6px',
      }}>{title}</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {options.map((option) => (
          <label key={option} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            cursor: 'pointer',
            padding: '6px',
            borderRadius: '6px',
            transition: 'background-color 0.2s',
            backgroundColor: selected.includes(option) ? '#eff6ff' : 'transparent',
          }}
          onMouseEnter={(e) => {
            if (!selected.includes(option)) {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
            }
          }}
          onMouseLeave={(e) => {
            if (!selected.includes(option)) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
          >
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => handleCheckboxChange(option)}
              style={{
                height: '14px',
                width: '14px',
                accentColor: '#3b82f6',
                cursor: 'pointer',
              }}
            />
            <span style={{ 
              fontSize: '14px',
              color: '#475569',
              userSelect: 'none',
              fontWeight: selected.includes(option) ? '500' : '400',
            }}>{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

const StockReportDisplay = ({ formData, filters, branchProfile, stockData }) => {
  const safeStockData = Array.isArray(stockData) ? stockData : [];
  const filteredData = safeStockData.filter(item => {
    let matchesFilters = true;
    if (formData.fromDate && formData.toDate) {
      const itemDate = new Date(item.refDate);
      const from = new Date(formData.fromDate);
      const to = new Date(formData.toDate);
      matchesFilters = matchesFilters && itemDate >= from && itemDate <= to;
    }
    if (filters.godown.length > 0 && !filters.godown.includes("All Warehouse")) {
      matchesFilters = matchesFilters && filters.godown.includes(item.location || "Unknown Location");
    }
    if (filters.group.length > 0 && !filters.group.includes("All Groups")) {
      matchesFilters = matchesFilters && filters.group.includes(item.groupName || "No Group Assigned");
    }
    if (filters.product.length > 0 && !filters.product.includes("All Products")) {
      matchesFilters = matchesFilters && filters.product.includes(item.itemDescription || "Unknown Product");
    }
    return matchesFilters;
  });

  const aggregatedData = filteredData.reduce((acc, item) => {
    const key = `${item.itemDescription}-${item.location}-${item.groupName}`;
    if (!acc[key]) {
      acc[key] = {
        itemDescription: item.itemDescription,
        location: item.location,
        groupName: item.groupName,
        qty: 0,
        value: 0,
      };
    }
    acc[key].qty += parseFloat(item.qty) || 0;
    acc[key].value += parseFloat(item.value) || 0;
    return acc;
  }, {});

  const sortedData = Object.values(aggregatedData).sort((a, b) =>
    a.itemDescription.localeCompare(b.itemDescription) ||
    a.location.localeCompare(b.location)
  );

  const totalQty = sortedData.reduce((sum, item) => sum + item.qty, 0);
  const totalValue = sortedData.reduce((sum, item) => sum + item.value, 0);

  const reportTitle = `Stock Summary Report`;
  const city = branchProfile.city || getCityFromAddress(branchProfile.address);

  // Adjust table structure based on stockType
  if (formData.stockType === "qty only") {
    const renderRows = sortedData.map((item, index) => (
      <tr key={`${item.itemDescription}-${item.location}-${index}`} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.itemDescription || 'Unknown Product'}</td>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>{item.qty.toFixed(2)}</td>
      </tr>
    ));

    return (
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        marginTop: '20px',
        border: '2px solid #3b82f6',
        borderRadius: '12px',
        fontFamily: 'Arial, sans-serif',
        fontSize: '12px',
        pageBreakInside: 'avoid',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
      }} className="print-only">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start', 
          marginBottom: '30px',
          paddingBottom: '20px',
          borderBottom: '2px solid #e2e8f0'
        }}>
          <div style={{ flex: 1 }}>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0', marginBottom: '15px', color: '#1e293b', textShadow: '1px 1px 2px rgba(0,0,0,0.1)' }}>
              {branchProfile.branchName}
            </h1>
            <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
              <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
                {reportTitle}
              </div>
            <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
  <span><strong>From:</strong> {formData.fromDate ? new Date(formData.fromDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') : 'N/A'}</span>
  <span><strong>To:</strong> {formData.toDate ? new Date(formData.toDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') : 'N/A'}</span>
</div>
            </div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
            color: 'white',
            padding: '15px 25px',
            borderRadius: '15px',
            textAlign: 'center',
            minWidth: '150px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
            <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
              Option: Qty Only
            </div>
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            fontSize: '11px', 
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Product Name</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Closing</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{
                    border: '1px solid #cbd5e1',
                    padding: '30px',
                    textAlign: 'center',
                    color: '#64748b',
                    fontStyle: 'italic',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc'
                  }}>
                    No stock data found for the selected criteria
                  </td>
                </tr>
              ) : renderRows}
              {sortedData.length > 0 && (
                <tr style={{ backgroundColor: '#fef3c7', fontWeight: 'bold', borderTop: '2px solid #f59e0b' }}>
                  <td colSpan="2" style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'center', fontSize: '12px', fontWeight: '600' }}>
                    Total
                  </td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>{totalQty.toFixed(2)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (formData.stockType === "qty with value") {
    const renderRows = sortedData.map((item, index) => (
      <tr key={`${item.itemDescription}-${item.location}-${index}`} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.itemDescription || 'Unknown Product'}</td>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>{item.qty.toFixed(2)}</td>
        <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>{item.value.toFixed(2)}</td>
      </tr>
    ));

    return (
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        marginTop: '20px',
        border: '2px solid #3b82f6',
        borderRadius: '12px',
        fontFamily: 'Arial, sans-serif',
        fontSize: '12px',
        pageBreakInside: 'avoid',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
      }} className="print-only">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start', 
          marginBottom: '30px',
          paddingBottom: '20px',
          borderBottom: '2px solid #e2e8f0'
        }}>
          <div style={{ flex: 1 }}>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0', marginBottom: '15px', color: '#1e293b', textShadow: '1px 1px 2px rgba(0,0,0,0.1)' }}>
              {branchProfile.branchName}
            </h1>
            <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
              <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
                {reportTitle}
              </div>
            <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
  <span><strong>From:</strong> {formData.fromDate ? new Date(formData.fromDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') : 'N/A'}</span>
  <span><strong>To:</strong> {formData.toDate ? new Date(formData.toDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') : 'N/A'}</span>
</div>
            </div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
            color: 'white',
            padding: '15px 25px',
            borderRadius: '15px',
            textAlign: 'center',
            minWidth: '150px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
            <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
              Option: Qty with Value
            </div>
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            fontSize: '11px', 
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Product Name</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Closing</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Closing Value</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{
                    border: '1px solid #cbd5e1',
                    padding: '30px',
                    textAlign: 'center',
                    color: '#64748b',
                    fontStyle: 'italic',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc'
                  }}>
                    No stock data found for the selected criteria
                  </td>
                </tr>
              ) : renderRows}
              {sortedData.length > 0 && (
                <tr style={{ backgroundColor: '#fef3c7', fontWeight: 'bold', borderTop: '2px solid #f59e0b' }}>
                  <td colSpan="2" style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'center', fontSize: '12px', fontWeight: '600' }}>
                    Total
                  </td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>{totalQty.toFixed(2)}</td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>{totalValue.toFixed(2)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Default detailed view (matching the image's full column set)
  const renderRows = sortedData.map((item, index) => (
    <tr key={`${item.itemDescription}-${item.location}-${index}`} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.itemDescription || 'Unknown Product'}</td>
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Opening */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Production */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Purchase */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Purchase Rtn */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Sales */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Sales Rtn */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Stock Adj */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>0.00</td> {/* Purchase Avg Cost */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>{item.qty.toFixed(2)}</td> {/* Closing */}
      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>{item.value.toFixed(2)}</td> {/* Closing Value */}
    </tr>
  ));

  return (
    <div style={{
      backgroundColor: 'white',
      padding: '30px',
      marginTop: '20px',
      border: '2px solid #3b82f6',
      borderRadius: '12px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      pageBreakInside: 'avoid',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
    }} className="print-only">
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start', 
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0', marginBottom: '15px', color: '#1e293b', textShadow: '1px 1px 2px rgba(0,0,0,0.1)' }}>
            {branchProfile.branchName}
          </h1>
          <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
            <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
              {reportTitle}
            </div>
         <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
  <span><strong>From:</strong> {formData.fromDate ? new Date(formData.fromDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') : 'N/A'}</span>
  <span><strong>To:</strong> {formData.toDate ? new Date(formData.toDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') : 'N/A'}</span>
</div>
          </div>
        </div>
        <div style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
          color: 'white',
          padding: '15px 25px',
          borderRadius: '15px',
          textAlign: 'center',
          minWidth: '150px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
          <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
            Option: Detailed
          </div>
        </div>
      </div>

      {/* <div style={{ overflowX: 'auto' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          fontSize: '11px', 
          border: '2px solid #3b82f6',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Product Name</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Opening</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Production</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Purchase</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Purchase Rtn</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Sales</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Sales Rtn</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Stock Adj</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Purchase Avg Cost</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Closing</th>
              <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Closing Value</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.length === 0 ? (
              <tr>
                <td colSpan="12" style={{
                  border: '1px solid #cbd5e1',
                  padding: '30px',
                  textAlign: 'center',
                  color: '#64748b',
                  fontStyle: 'italic',
                  fontSize: '14px',
                  backgroundColor: '#f8fafc'
                }}>
                  No stock data found for the selected criteria
                </td>
              </tr>
            ) : renderRows}
            {sortedData.length > 0 && (
              <tr style={{ backgroundColor: '#fef3c7', fontWeight: 'bold', borderTop: '2px solid #f59e0b' }}>
                <td colSpan="10" style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'center', fontSize: '12px', fontWeight: '600' }}>
                  Grand Total
                </td>
                <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>{totalQty.toFixed(2)}</td>
                <td style={{ border: '1px solid #cbd5e1', padding: '10px', textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>{totalValue.toFixed(2)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div> */}
    </div>
  );
};

// Main Stock Summary Report Generator Component
const StockSummaryReportGenerator = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [type, setType] = useState('-SELECT-');
  const [stockType, setStockType] = useState('-SELECT-');
  const [year, setYear] = useState('');
  const [reportType, setReportType] = useState('detailed');
  const [filters, setFilters] = useState({
    godown: ["All Warehouse"],
    group: ["All Groups"],
    product: ["All Products"]
  });
  const [godowns, setGodowns] = useState(["All Warehouse", "WAREHOUSE"]);
  const [groups, setGroups] = useState(["All Groups", "GENERAL", "VEGETABLE", "ALUMINIUM FOIL", "BEARING", "GROCERY"]);
  const [products, setProducts] = useState(["All Products", "PRESTIGE 1.5L", "GAS 21 KG", "BT 4 LB", "SCREW DRIVER", "FRONT RIMPER", "ULTRA SLIM LED DISPLAY", "CHAIN & DENT IN AIR"]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showReport, setShowReport] = useState(false);
  const [branchProfile, setBranchProfile] = useState({
    branchName: "SUPREME TRADERS",
    address: "",
    phone: "",
    city: ""
  });
  const [stockData, setStockData] = useState([]);
  const [productGroupMap, setProductGroupMap] = useState({});
  const [productCategoryMap, setProductCategoryMap] = useState({});
  const [productBrandMap, setProductBrandMap] = useState({});

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  // Firebase Auth and Data Loading
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        loadFirebaseData(user);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

// Inside StockSummaryReportGenerator
const loadFirebaseData = (user) => {
  const encodedEmail = encodeEmailForPath(user.email);

  // Load Branch Profile
  const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
  onValue(branchProfileRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const profiles = Object.values(data);
      const latestProfile = profiles[profiles.length - 1];
      setBranchProfile({
        branchName: latestProfile.branchName || "SUPREME TRADERS",
        address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
        phone: latestProfile.mobileNo || '',
        city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
      });
    }
  });

  // Load Godowns (Stores/Warehouses)
  const storesRef = ref(database, `users/${encodedEmail}/stores`);
  onValue(storesRef, (snapshot) => {
    const godownsData = ["All Warehouse"];
    if (snapshot.exists()) {
      snapshot.forEach((childSnapshot) => {
        const store = childSnapshot.val();
        if (store.name && !godownsData.includes(store.name)) {
          godownsData.push(store.name);
        }
      });
    }
    setGodowns(godownsData);
    if (!filters.godown.length) {
      setFilters(prev => ({ ...prev, godown: [godownsData[0]] }));
    }
  });

  // Load Groups
  const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
  onValue(groupsRef, (snapshot) => {
    const groupsData = ["All Groups"];
    if (snapshot.exists()) {
      snapshot.forEach((childSnapshot) => {
        const group = childSnapshot.val();
        if (group.name && !groupsData.includes(group.name)) {
          groupsData.push(group.name);
        }
      });
    }
    setGroups(groupsData);
    if (!filters.group.length) {
      setFilters(prev => ({ ...prev, group: [groupsData[0]] }));
    }
  });

  // Load Products and their mappings
  const productsRef = ref(database, `users/${encodedEmail}/products`);
  onValue(productsRef, (snapshot) => {
    const productsData = ["All Products"];
    const groupMap = {};
    const categoryMap = {};
    const brandMap = {};
    if (snapshot.exists()) {
      snapshot.forEach((childSnapshot) => {
        const product = childSnapshot.val();
        if (product.productName && !productsData.includes(product.productName)) {
          productsData.push(product.productName);
          groupMap[product.productName] = product.groupName || product.group || 'No Group Assigned';
          categoryMap[product.productName] = product.category || 'Unknown Category';
          brandMap[product.productName] = product.brand || 'Unknown Brand';
        }
      });
    }
    setProducts(productsData);
    setProductGroupMap(groupMap);
    setProductCategoryMap(categoryMap);
    setProductBrandMap(brandMap);
    if (!filters.product.length) {
      setFilters(prev => ({ ...prev, product: [productsData[0]] }));
    }
  });

  // Load Stock Data (combine stockEntries and openingStock)
  const combineStockData = () => {
    const stockRecords = [];

    // Fetch stockEntries
    const stocksRef = ref(database, `users/${encodedEmail}/stockEntries`);
    onValue(stocksRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        Object.entries(data).forEach(([stockId, stockData]) => {
          if (stockData.items && Array.isArray(stockData.items)) {
            stockData.items.forEach(item => {
              if (item.itemDescription) {
                stockRecords.push({
                  stockId: stockId,
                  refNo: stockData.refNo || 'N/A',
                  refDate: stockData.refDate || '',
                  location: stockData.location || 'Unknown Location',
                  itemDescription: item.itemDescription || 'Unknown Product',
                  groupName: productGroupMap[item.itemDescription] || 'No Group Assigned',
                  category: productCategoryMap[item.itemDescription] || 'Unknown Category',
                  brand: productBrandMap[item.itemDescription] || 'Unknown Brand',
                  uom: item.uom || '',
                  qty: parseFloat(item.qty) || 0,
                  mrp: parseFloat(item.mrp) || 0,
                  value: parseFloat(item.value) || 0,
                  barcode: item.barcode || item.itemCode || '',
                  commodityCode: item.commodityCode || item.category || '',
                  type: 'stockEntry'
                });
              }
            });
          }
        });
      }
      setStockData([...stockRecords]); // Update stockData after fetching both
    });

    // Fetch openingStock
    const openingStockRef = ref(database, `users/${encodedEmail}/openingStock`);
    onValue(openingStockRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        Object.entries(data).forEach(([stockId, stockData]) => {
          if (stockData.items && Array.isArray(stockData.items)) {
            stockData.items.forEach(item => {
              if (item.itemDescription) {
                stockRecords.push({
                  stockId: stockId,
                  refNo: stockData.refNo || 'N/A',
                  refDate: stockData.refDate || '',
                  location: stockData.location || 'Unknown Location',
                  itemDescription: item.itemDescription || 'Unknown Product',
                  groupName: productGroupMap[item.itemDescription] || 'No Group Assigned',
                  category: productCategoryMap[item.itemDescription] || 'Unknown Category',
                  brand: productBrandMap[item.itemDescription] || 'Unknown Brand',
                  uom: item.uom || '',
                  qty: parseFloat(item.qty) || 0,
                  mrp: parseFloat(item.mrp) || 0,
                  value: parseFloat(item.value) || 0,
                  barcode: item.barcode || item.itemCode || '',
                  commodityCode: item.commodityCode || item.category || '',
                  type: 'openingStock'
                });
              }
            });
          }
        });
      }
      setStockData([...stockRecords]); // Update stockData after fetching both
    });
  };

  combineStockData();

  return () => {
    off(branchProfileRef);
    off(storesRef);
    off(groupsRef);
    off(productsRef);
    off(ref(database, `users/${encodedEmail}/stockEntries`));
    off(ref(database, `users/${encodedEmail}/openingStock`));
  };
};

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleGenerateReport = () => {
    setShowReport(true);
  };

  const handlePrint = () => {
    const printContent = (
      <StockReportDisplay 
        formData={{ fromDate, toDate, type, stockType, reportType }}
        filters={filters}
        branchProfile={branchProfile}
        stockData={stockData}
      />
    );

    const htmlString = ReactDOMServer.renderToString(printContent);

    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
      <html>
        <head>
          <title>Stock Summary Report</title>
          <style>
            body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
            @page { size: A4; margin: 5mm; }
            table { page-break-inside: auto; }
            tr { page-break-inside: avoid; page-break-after: auto; }
            .print-only { display: block !important; }
          </style>
        </head>
        <body>
          <div id="print-content">${htmlString}</div>
          <script>
            setTimeout(function() {
              window.print();
              window.close();
            }, 500);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const formData = {
    fromDate,
    toDate,
    type,
    stockType,
    reportType
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        fontSize: '18px',
        color: '#64748b',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div>Loading Stock Data...</div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '3rem', 
        color: '#64748b', 
        fontSize: '18px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <h2 style={{ color: '#1e293b', marginBottom: '16px' }}>Authentication Required</h2>
        <p>Please login to access the Stock Summary Report Generator</p>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      maxWidth: '90rem',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      padding: '32px',
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      border: '1px solid #e2e8f0'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @media print {
            body * {
              visibility: hidden;
            }
            .print-only, .print-only * {
              visibility: visible;
            }
            .print-only {
              position: absolute;
              left: 0;
              top: 0;
              width: '100%',
              margin: 0,
              padding: 20px,
              box-shadow: none,
              border: none;
            }
          }
        `}
      </style>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{
          width: '6px',
          height: '32px',
          backgroundColor: '#3b82f6',
          borderRadius: '3px'
        }}></div>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1e293b',
          margin: '0'
        }}>Stock Summary Report Generator</h1>
      </div>
      
      {/* Filters */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '32px',
        padding: '24px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              backgroundColor: 'white',
              cursor: 'pointer',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              backgroundColor: 'white',
              cursor: 'pointer',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
       
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>Stock Type</label>
          <select
            value={stockType}
            onChange={(e) => setStockType(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              backgroundColor: 'white',
              cursor: 'pointer',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          >
            <option value="-SELECT-">-SELECT-</option>
            <option value="qty only">Qty Only</option>
            <option value="qty with value">Qty With Value</option>
          </select>
        </div>
      
      </div>

      {/* Filter Checkboxes */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '32px'
      }}>
        <FilterSection 
          title="Godown" 
          options={godowns} 
          selected={filters.godown} 
          onChange={(value) => handleFilterChange("godown", value)}
        />
        <FilterSection 
          title="Group" 
          options={groups} 
          selected={filters.group} 
          onChange={(value) => handleFilterChange("group", value)}
        />
        <FilterSection 
          title="Product" 
          options={products} 
          selected={filters.product} 
          onChange={(value) => handleFilterChange("product", value)}
        />
      </div>
  
      {/* Action Buttons */}
      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        marginBottom: '32px',
        justifyContent: 'center'
      }}>
        <button
          onClick={handleGenerateReport}
          style={{
            background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Generate Report
        </button>
        <button
          onClick={handlePrint}
          style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '120px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Print Report
        </button>
      </div>
  
      {/* Stock Report Display */}
      {showReport && stockData && (
        <StockReportDisplay 
          formData={formData}
          filters={filters}
          branchProfile={branchProfile}
          stockData={stockData}
        />
      )}
    </div>
  );
};

export default StockSummaryReportGenerator;